/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check-circle': {
    width: 12,
    height: 12,
    viewBox: '0 0 15 15',
    data: '<path pid="0" d="M13.75 6.925V7.5a6.25 6.25 0 11-3.706-5.713" _stroke="#62E2AA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M13.75 2.5L7.5 8.756 5.625 6.881" _stroke="#62E2AA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/check-circle.js